import { ChampionshipsProxy } from 'services'

import * as types from './types'

export const loadChampionshipAttempt = () => ({
  type: types.LOAD_CHAMPIONSHIP_ATTEMPT
})
export const loadChampionshipSuccess = (championship) => ({
  type: types.LOAD_CHAMPIONSHIP_SUCCESS,
  championship
})
export const loadChampionshipFailure = (error) => ({
  type: types.LOAD_CHAMPIONSHIP_FAILURE,
  error
})

export const resetValue = (field) => ({
  type: types.RESET_VALUE,
  field
})

export const createChampionshipAttempt = () => ({
  type: types.CREATE_CHAMPIONSHIP_ATTEMPT
})
export const createChampionshipSuccess = () => ({
  type: types.CREATE_CHAMPIONSHIP_SUCCESS
})
export const createChampionshipFailure = (error) => ({
  type: types.CREATE_CHAMPIONSHIP_FAILURE,
  error
})

export const updateChampionshipAttempt = () => ({
  type: types.UPDATE_CHAMPIONSHIP_ATTEMPT
})
export const updateChampionshipSuccess = () => ({
  type: types.UPDATE_CHAMPIONSHIP_SUCCESS
})
export const updateChampionshipFailure = (error) => ({
  type: types.UPDATE_CHAMPIONSHIP_FAILURE,
  error
})

export const reactAttempt = () => ({
  type: types.REACT_ATTEMPT
})
export const reactSuccess = (championship) => ({
  type: types.REACT_SUCCESS,
  championship
})
export const reactFailure = (error) => ({
  type: types.REACT_FAILURE,
  error
})

export const setImageAttempt = () => ({
  type: types.SET_IMAGE_ATTEMPT
})
export const setImageSuccess = (championship) => ({
  type: types.SET_IMAGE_SUCCESS,
  championship
})
export const setImageFailure = (error) => ({
  type: types.SET_IMAGE_FAILURE,
  error
})

export const deleteImageAttempt = () => ({
  type: types.DELETE_IMAGE_ATTEMPT
})
export const deleteImageSuccess = (championship) => ({
  type: types.DELETE_IMAGE_SUCCESS,
  championship
})
export const deleteImageFailure = (error) => ({
  type: types.DELETE_IMAGE_FAILURE,
  error
})

export const loadResultsAttempt = () => ({
  type: types.LOAD_RESULTS_ATTEMPT
})
export const loadResultsSuccess = (results) => ({
  type: types.LOAD_RESULTS_SUCCESS,
  results
})
export const loadResultsFailure = (error) => ({
  type: types.LOAD_RESULTS_FAILURE,
  error
})
export const loadEventCircuitCategoryResultsAttempt = () => ({
  type: types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_ATTEMPT
})
export const loadEventCircuitCategoryResultsSuccess = (eventCircuitCategoryResults) => ({
  type: types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_SUCCESS,
  eventCircuitCategoryResults
})
export const loadEventCircuitCategoryResultsFailure = (error) => ({
  type: types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_FAILURE,
  error
})

export const loadChampionship = (slugUrlOrId) => async (dispatch) => {
  try {
    dispatch(loadChampionshipAttempt())

    const proxy = new ChampionshipsProxy()
    const championship = await proxy.get(slugUrlOrId)
    dispatch(loadChampionshipSuccess(championship))
    return true
  } catch (error) {
    dispatch(loadChampionshipFailure(error))
    return false
  }
}

export const createChampionship = (championship) => async (dispatch) => {
  try {
    dispatch(createChampionshipAttempt())

    const proxy = new ChampionshipsProxy()
    const data = await proxy.post(championship)

    dispatch(createChampionshipSuccess())
    return data
  } catch (error) {
    dispatch(createChampionshipFailure(error))
  }
}

export const updateChampionship = (id, championship) => async (dispatch) => {
  try {
    dispatch(updateChampionshipAttempt())

    const proxy = new ChampionshipsProxy()
    const data = await proxy.put(id, championship)

    dispatch(updateChampionshipSuccess())
    return data
  } catch (error) {
    dispatch(updateChampionshipFailure(error))
  }
}

export const react = (championship) => async (dispatch) => {
  try {
    dispatch(reactAttempt())

    const {
      id,
      loggedUserMetadata: { like }
    } = championship

    const proxy = new ChampionshipsProxy()

    if (like) {
      await proxy.putDisLike(id)
      championship.likesCount--
    } else {
      await proxy.putLike(id)
      championship.likesCount++
    }

    championship.loggedUserMetadata.like = !like

    dispatch(reactSuccess(championship))
  } catch (error) {
    dispatch(reactFailure(error))
  }
}

export const setImage = (id, file) => async (dispatch) => {
  try {
    dispatch(setImageAttempt())

    const proxy = new ChampionshipsProxy()
    const championship = await proxy.putImage(id, file)
    dispatch(setImageSuccess(championship))
    return true
  } catch (error) {
    dispatch(setImageFailure(error))
    return false
  }
}

export const deleteImage = (championship) => async (dispatch) => {
  try {
    const { id } = championship
    dispatch(deleteImageAttempt())
    const proxy = new ChampionshipsProxy()
    await proxy.deleteImage(id)
    championship.profileImages = null
    dispatch(deleteImageSuccess(championship))
  } catch (error) {
    dispatch(deleteImageFailure(error))
  }
}

export const loadResults = (id) => async (dispatch) => {
  try {
    dispatch(loadResultsAttempt())
    const proxy = new ChampionshipsProxy()
    const data = await proxy.getResults(id)
    dispatch(loadResultsSuccess(data))
  } catch (error) {
    dispatch(loadResultsFailure(error))
  }
}

export const loadEventCircuitCategoryResults = (id, options) => async (dispatch) => {
  try {
    dispatch(loadEventCircuitCategoryResultsAttempt())

    const proxy = new ChampionshipsProxy()
    const data = await proxy.postEventCircuitCategoryResults(id, options)

    dispatch(loadEventCircuitCategoryResultsSuccess(data))

    return data
  } catch (error) {
    dispatch(loadEventCircuitCategoryResultsFailure(error))
  }
}
